const DUMMYTEXT =
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer at aliquet leo. Quisque arcu nunc, auctor sed urna a, auctor blandit quam. Interdum et malesuada fames ac ante ipsum primis in faucibus. Phasellus faucibus interdum fermentum. Proin fringilla laoreet tristique. Integer tincidunt semper est, quis interdum justo semper vitae. Proin cursus, diam sed blandit lacinia, ipsum lorem rhoncus diam, a aliquam turpis quam ac nunc. Ut facilisis commodo augue sed venenatis. Nullam porta nunc sit amet ex pellentesque suscipit. Maecenas lobortis, elit a vulputate aliquet, ligula purus imperdiet urna, at placerat purus lacus eu ligula. Praesent eleifend, sapien a cursus dignissim, dolor arcu ultrices nisi, vitae condimentum ex ante eu ligula. Integer nisi augue, rutrum vitae vestibulum ac, volutpat sit amet lectus. Cras maximus convallis augue vitae luctus. Maecenas ut tortor eu odio eleifend rutrum id et ex.";

export default class DummyText {
  constructor(dom) {
    this.dom = dom;
    this.numChar = this.dom.getAttribute("js-dummytext");
    this.fillDummyText();
  }

  fillDummyText() {
    let content = DUMMYTEXT.slice(0, this.numChar);
    this.dom.innerText = content;
  }
}
